import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

// Animation variants
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  out: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: [0.4, 0, 0.2, 1],
    },
  },
};

// Animation settings for children components
const childVariants = {
  initial: { opacity: 0, y: 20 },
  in: i => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.5,
      ease: [0.4, 0, 0.2, 1],
    },
  }),
};

/**
 * Page transition component for smooth page animations
 * @param {Object} props - Component props
 * @param {ReactNode} props.children - Child components to animate
 * @param {string} props.className - Optional CSS class
 * @returns {JSX.Element} - Animated page component
 */
const PageTransition = ({ children, className }) => {
  return (
    <Box
      component={motion.div}
      className={className}
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      style={{ width: '100%' }}
    >
      {React.Children.map(children, (child, i) => 
        child ? (
          <motion.div
            custom={i}
            variants={childVariants}
            initial="initial"
            animate="in"
          >
            {child}
          </motion.div>
        ) : null
      )}
    </Box>
  );
};

export default PageTransition; 